import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonWithIcon } from '@ff-os/shared-react/components/buttons/button-with-icon/ButtonWithIcon';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import styles from './ContextMenuExpanded.module.scss';

export const ContextMenuExpanded = ({ replace, crop }: Props) => {
    const { t } = useTranslation();
    return (
        <div className={styles.container}>
            <Grid direction='column' align='stretch' gap='xs'>
                <Cell>
                    <ButtonWithIcon small icon='general-ui-replace' position='right'
                        className={styles.button} onClick={replace}
                        title={t('image_uploader.replace')}>
                        {t('image_uploader.replace')}
                    </ButtonWithIcon>
                </Cell>
                <Cell>
                    <ButtonWithIcon small style='outline' icon='general-ui-crop' position='right'
                        className={styles.button} onClick={crop}
                        title={t('image_uploader.replace')}>
                        {t('image_uploader.edit')}
                    </ButtonWithIcon>
                </Cell>
            </Grid>
        </div>
    );
};

type Props = {
    replace: () => void;
    crop: () => void;
};